export interface GossipTimelineItem {
  time: string;
  stage: "发生" | "发酵" | "回应" | "后续";
  title: string;
  desc: string;
}

export interface GossipEvent {
  id: number;
  slug: string;
  title: string;
  category: string;
  cover: string;
  summary: string;
  heat: number;
  status: "持续发酵" | "已澄清" | "进行中";
  publishedAt: string;
  updatedAt: string;
  duration: string;
  tags: string[];
  timeline: GossipTimelineItem[];
  paragraphs: string[];
  related: number[];
}

export const gossipEvents: GossipEvent[] = [
  {
    id: 1,
    slug: "summer-music-festival-extra-show",
    title: "夏日音乐节加场风波：临时加开一晚到底卡在哪",
    category: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20festival%20stage%20silhouette%20cut%20from%20warm%20coral%20paper%2C%20green%20and%20gold%20geometric%20shapes%20on%20a%20soft%20cream%20backdrop%2C%20minimal%20magazine%20collage%20style%2C%20gentle%20studio%20light%2C%20clean%20composition%20without%20text&width=1200&height=800&seq=gua-event-music-01&orientation=landscape",
    summary:
      "一场原本两天的音乐节在开票后突然宣布加开第三晚，阵容排布、场地档期和退改规则同时被推上讨论区，热度一路走高。",
    heat: 9820,
    status: "持续发酵",
    publishedAt: "2026-09-08",
    updatedAt: "2026-09-10",
    duration: "3 天",
    tags: ["音乐节", "加场", "票务"],
    timeline: [
      {
        time: "09-08 10:20",
        stage: "发生",
        title: "主办方官宣加开第三晚",
        desc: "官方账号发布加场公告，称「响应乐迷呼声」，但未同步公布完整阵容排序。",
      },
      {
        time: "09-08 15:40",
        stage: "发酵",
        title: "已购票乐迷讨论退改规则",
        desc: "已购买两日通票的用户发现无法直接换购加场日，讨论集中在「差价补偿」和「换票通道」。",
      },
      {
        time: "09-09 09:10",
        stage: "回应",
        title: "主办方追加换票说明",
        desc: "主办方补充说明将开放限时换票窗口，并承诺加场日的舞台与主日保持同一套制作标准。",
      },
      {
        time: "09-10 11:30",
        stage: "后续",
        title: "场地方回应档期协调",
        desc: "场地方表示加场需重新评估周边交通与噪音时段，最终执行方案仍以官方公告为准。",
      },
    ],
    paragraphs: [
      "这场音乐节的加场消息来得突然。原本只安排两晚的演出，在首轮开票后不到一周就宣布增加一晚，公告里用词克制，只提到「响应乐迷呼声」，但没有把最关键的两件事说清楚：加场日到底唱谁，以及已经买了两日通票的人该怎么处理。",
      "讨论真正升温的点在于换票规则。不少乐迷反映，通票用户想换成含加场日的三日票，需要先退再买，而退票通道和加场购票通道并不同时开放，中间存在一个几小时的空窗。对热门阵容来说，这几小时足够让心仪的位置被抢空。",
      "到了回应的阶段，主办方补上了换票窗口的说明，也承诺加场日沿用同一套舞台制作，算是把最大的疑虑按住了一部分。但场地方关于交通与噪音时段的提醒，又让「加场是否会影响散场效率」成了新的讨论方向。",
      "按目前的节奏，这件事的关键变量是换票窗口的实际执行和加场阵容的正式公布。只要这两点落地，热度大概率会回落，否则讨论还会围绕「先卖票再说细节」的模式继续延伸。",
    ],
    related: [8, 3, 2],
  },
  {
    id: 2,
    slug: "hit-drama-cast-swap",
    title: "爆款剧临阵换角疑云：官微一句「档期调整」够不够",
    category: "影视热剧",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20folded%20film%20clapperboard%20and%20script%20pages%20in%20coral%20and%20green%20paper%20cutouts%2C%20soft%20cream%20background%2C%20minimal%20magazine%20collage%20composition%2C%20warm%20studio%20lighting%2C%20no%20text&width=1200&height=800&seq=gua-event-drama-02&orientation=landscape",
    summary:
      "一部口碑热播剧在杀青前调整了男二号演员，官微只回应「档期调整」，粉丝与剧迷从片场路透一路讨论到角色走向。",
    heat: 8760,
    status: "已澄清",
    publishedAt: "2026-09-05",
    updatedAt: "2026-09-09",
    duration: "4 天",
    tags: ["剧集", "换角", "档期"],
    timeline: [
      {
        time: "09-05 18:00",
        stage: "发生",
        title: "片场路透出现陌生面孔",
        desc: "有剧迷在片场外围拍到身着戏服的新面孔，角色定位与已官宣男二高度重合。",
      },
      {
        time: "09-06 12:15",
        stage: "发酵",
        title: "角色戏份讨论扩散",
        desc: "讨论从「换没换人」转向「已拍部分怎么办」，延伸出补拍、剪辑两种猜测。",
      },
      {
        time: "09-07 20:40",
        stage: "回应",
        title: "官微发布档期说明",
        desc: "官微确认原演员因档期与拍摄计划冲突退出，已拍摄戏份将按合理方案重新处理。",
      },
      {
        time: "09-09 10:05",
        stage: "后续",
        title: "制作方补充剪辑说明",
        desc: "制作方表示不会影响整体节奏，后续将公布正式剧照以正视听。",
      },
    ],
    paragraphs: [
      "换角传闻的起点其实很朴素，就是一张片场外围的偷拍。真正让它变成热点的，是这张照片里的人和已经官宣的男二号在造型上过于接近。",
      "剧迷的担心集中在同一个问题上：如果中途换人，已经拍完的戏份是不是要重拍？重拍意味着周期拉长，不重拍又可能留下连贯性上的痕迹。两种猜测在讨论区各有支持者，也把话题从娱乐层面推到了制作层面。",
      "官微的回应来得不算慢，「档期调整」四个字给出了原因，却没有完全解答过程。好在此后制作方补充了剪辑处理的说明，并承诺公布正式剧照，才让「剧会不会崩」的焦虑缓和下来。",
      "这件事最终被归类为「已澄清」，但它留下了一个值得记住的模板：涉及作品质量的变动，一句简短说明很难服众，配套的实质性信息才是降温的关键。",
    ],
    related: [7, 3, 1],
  },
  {
    id: 3,
    slug: "variety-show-editing-dispute",
    title: "综艺剪辑争议全记录：一句话被拆成三个镜头之后",
    category: "综艺观察",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20stacked%20film%20frames%20and%20scissors%20cut%20from%20coral%20and%20mustard%20paper%2C%20soft%20cream%20backdrop%2C%20minimal%20magazine%20collage%20style%2C%20warm%20studio%20light%2C%20clean%20and%20textless&width=1200&height=800&seq=gua-event-variety-03&orientation=landscape",
    summary:
      "一期综艺的预告把嘉宾的一句话拆进了三个不同场景，正片播出后观众发现前后语境并不连贯，剪辑节奏成了主角。",
    heat: 7540,
    status: "持续发酵",
    publishedAt: "2026-09-06",
    updatedAt: "2026-09-10",
    duration: "4 天",
    tags: ["综艺", "剪辑", "预告"],
    timeline: [
      {
        time: "09-06 21:00",
        stage: "发生",
        title: "预告片放出高张力片段",
        desc: "预告用快切方式呈现嘉宾对话，配乐与字幕引导出明显的冲突感。",
      },
      {
        time: "09-07 22:00",
        stage: "发酵",
        title: "正片播出前后语境对不上",
        desc: "观众逐帧比对后认为同一句话被拆到三个场景，语境被重新组织。",
      },
      {
        time: "09-09 14:20",
        stage: "回应",
        title: "节目组解释时长取舍",
        desc: "节目组称预告需在极短时间内呈现看点，正片以完整体验为准。",
      },
      {
        time: "09-10 09:40",
        stage: "后续",
        title: "剪辑师发文谈行业惯例",
        desc: "从业者发长文解释预告与正片的制作逻辑，讨论逐渐转为对剪辑行业科普。",
      },
    ],
    paragraphs: [
      "这期综艺的争议几乎完全发生在剪辑层面。预告里最抓人的一段对话，在正片中被分散到了三个不同时间点，观众回看时发现前后语境接不上，于是「是不是刻意制造冲突」的疑问出现了。",
      "有趣的是，讨论在两天内完成了一次转向。最初大家争论的是节目组的动机，随后有从业者下场科普，说明预告和正片往往由不同团队、按不同目标剪辑，快切和重组在业内并不罕见。话题因此从情绪化转向了知识化。",
      "节目组的回应属于常见口径，强调正片才是完整体验。这个说法有道理，但并没有解决观众的核心困惑：如果预告呈现的不是真实语境，它到底算不算一种误导。",
      "目前话题仍在延续，且讨论质量意外地高。对综艺来说，这或许是一次把制作流程摊开给观众看的机会，而不是单纯的口水战。",
    ],
    related: [1, 9, 6],
  },
  {
    id: 4,
    slug: "brand-ambassador-pulled",
    title: "顶流代言突遭下架：品牌与工作室的沉默 12 小时",
    category: "品牌公关",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20an%20empty%20product%20pedestal%20with%20coral%20and%20green%20paper%20shapes%2C%20gold%20accent%20stripes%2C%20soft%20cream%20background%2C%20minimal%20magazine%20collage%2C%20warm%20studio%20light%2C%20no%20text&width=1200&height=800&seq=gua-event-brand-04&orientation=landscape",
    summary:
      "某品牌在深夜悄悄撤下了首页的代言视觉，合作方没有同步发声，12 小时的信息空窗被迅速解读成各种版本。",
    heat: 8210,
    status: "进行中",
    publishedAt: "2026-09-07",
    updatedAt: "2026-09-10",
    duration: "3 天",
    tags: ["代言", "公关", "品牌"],
    timeline: [
      {
        time: "09-07 01:20",
        stage: "发生",
        title: "品牌首页代言视觉被替换",
        desc: "网友发现品牌官网与电商首页的主视觉更换，代言相关内容暂时不可见。",
      },
      {
        time: "09-07 09:00",
        stage: "发酵",
        title: "话题冲上讨论榜",
        desc: "双方均未发声，空窗期引发各种猜测，二手平台搜索量同步上升。",
      },
      {
        time: "09-07 13:30",
        stage: "回应",
        title: "品牌客服给出统一口径",
        desc: "客服表示「正在按计划调整页面素材」，未提及合作关系是否变化。",
      },
      {
        time: "09-10 10:00",
        stage: "后续",
        title: "工作室发布活动预告",
        desc: "工作室照常发布线下活动预告，被解读为侧面回应，热度小幅回落。",
      },
    ],
    paragraphs: [
      "这件事最有意思的地方不在视觉本身，而在那 12 小时。品牌在深夜换掉了首页主视觉，按说是个不需要解释的常规操作，但当操作对象是代言人相关内容，且合作方完全没有同步动作时，沉默本身就成了信息。",
      "空窗期里，各种版本的解释都冒了出来。品牌客服在第二天中午给出了一个中性口径——「按计划调整页面素材」，既没说合作继续，也没说结束。这种模糊表达通常能拖住舆论，但也容易让猜测继续生长。",
      "转机出现在工作室照常发布线下活动预告。一个不带解释的日常动作，反而让「关系是否生变」的讨论降温，说明在公关节奏上，保持对外正常输出有时比发一份声明更有效。",
      "截至目前事件被标记为进行中。接下来值得关注的是一个明确节点，比如新一季物料是否沿用，或者双方是否在重要节点互动，这类信号比任何传闻都更有参考价值。",
    ],
    related: [2, 6, 9],
  },
  {
    id: 5,
    slug: "livestream-price-war",
    title: "直播间价格战复盘：同一款货，三个链接三个价",
    category: "网红动态",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20ring%20light%20and%20price%20tag%20cut%20from%20coral%20and%20green%20paper%2C%20gold%20coin%20shapes%2C%20soft%20cream%20backdrop%2C%20minimal%20magazine%20collage%2C%20warm%20light%2C%20textless&width=1200&height=800&seq=gua-event-live-05&orientation=landscape",
    summary:
      "同一天里三位主播带货同款商品，三个链接价格不一，其中两个标注「全网最低」，消费者开始认真比价并追问保价机制。",
    heat: 6930,
    status: "已澄清",
    publishedAt: "2026-09-04",
    updatedAt: "2026-09-08",
    duration: "4 天",
    tags: ["直播", "比价", "保价"],
    timeline: [
      {
        time: "09-04 20:00",
        stage: "发生",
        title: "三位主播同款不同价",
        desc: "网友整理出三场直播的同一款商品链接，价差在几十元区间浮动。",
      },
      {
        time: "09-05 11:30",
        stage: "发酵",
        title: "保价机制被集中追问",
        desc: "已下单的消费者想知道能不能补差价，评论区出现大量保价咨询。",
      },
      {
        time: "09-06 16:00",
        stage: "回应",
        title: "平台解释价格构成",
        desc: "平台说明价差来自赠品组合和优惠券配置差异，并非商品本身定价不同。",
      },
      {
        time: "09-08 10:00",
        stage: "后续",
        title: "各直播间开放限时补差",
        desc: "三方陆续给出限时补差方案，话题热度回落。",
      },
    ],
    paragraphs: [
      "比价这件事，一旦有人认真做表格，热度就下不来了。这次被整理出来的是同款商品在三个直播间里的三个链接，价差最大的一组接近一顿饭钱，而其中两个还在醒目位置标着「全网最低」。",
      "消费者真正关心的其实不是谁更便宜，而是「我现在下单会不会明天就亏」。所以讨论很快从价格本身，转向了保价机制：保多久、怎么申请、赠品算不算在保价范围内。",
      "平台的解释相对清楚，价差主要来自赠品组合与优惠券配置，商品本身的定价是一致的。这个说法在逻辑上站得住，但并没有直接回答「标全网最低是否严谨」，所以讨论又延伸到了用语规范。",
      "最终三方先后给出了限时补差方案，事情算是收尾。对消费者来说，这次事件留下的实用结论只有一个：下单前先看清赠品和券的配置，比只看价格数字更靠谱。",
    ],
    related: [9, 4, 3],
  },
  {
    id: 6,
    slug: "awards-backstage-moment",
    title: "颁奖礼后台小插曲：一段 8 秒视频的完整前后文",
    category: "娱乐八卦",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20trophy%20and%20backstage%20curtain%20cut%20from%20coral%20gold%20and%20green%20paper%2C%20soft%20cream%20background%2C%20minimal%20magazine%20collage%2C%20warm%20studio%20light%2C%20no%20text&width=1200&height=800&seq=gua-event-awards-06&orientation=landscape",
    summary:
      "颁奖礼后台一段 8 秒视频被单独截出传播，配文与现场完整流程存在出入，随后有现场工作人员出面还原全过程。",
    heat: 5880,
    status: "进行中",
    publishedAt: "2026-09-03",
    updatedAt: "2026-09-09",
    duration: "6 天",
    tags: ["颁奖礼", "后台", "现场"],
    timeline: [
      {
        time: "09-03 22:30",
        stage: "发生",
        title: "后台短视频开始传播",
        desc: "一段 8 秒的走廊片段被配文传播，内容指向现场互动出现尴尬。",
      },
      {
        time: "09-04 10:00",
        stage: "发酵",
        title: "配文版本出现多个变体",
        desc: "同一段视频在不同账号下的说明各不相同，阅读量持续攀升。",
      },
      {
        time: "09-06 15:20",
        stage: "回应",
        title: "现场工作人员还原流程",
        desc: "工作人员发出完整时间线，说明该片段前后还有引导和合影环节。",
      },
      {
        time: "09-09 12:00",
        stage: "后续",
        title: "事件转为媒介素养讨论",
        desc: "讨论逐渐转为对短视频断章取义的反思，热度缓慢下降。",
      },
    ],
    paragraphs: [
      "一段 8 秒的视频能有多大信息量？这次的答案是：在配文的加持下，足以撑起一轮持续数天的讨论。原始片段本身只是一条后台走廊，但被加上解释性文字后，故事就完整了。",
      "真正的混乱来自配文版本太多。同一段画面，在不同账号那里被描述成不同的起因和结果，读者很难分辨哪一版更接近现场。信息的密度看似很高，实际上有效信息很少。",
      "现场工作人员发出的完整时间线是转折点。加上前后文的引导与合影环节之后，那段 8 秒画面立刻失去了戏剧性，也让不少已经转发过的账号悄悄删了帖。",
      "这件事最后的落点比较特别，讨论没有停留在谁对谁错，而是转向了短视频语境下的媒介素养。对于一个吃瓜站点来说，这类转向其实是值得记录的，因为它把「追瓜」变成了一次对信息本身的复盘。",
    ],
    related: [4, 3, 2],
  },
  {
    id: 7,
    slug: "new-drama-billing-order",
    title: "新剧开机番位排序：一张海报引发的排序研究",
    category: "影视热剧",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20overlapping%20poster%20cards%20in%20coral%20mustard%20and%20green%2C%20soft%20cream%20background%2C%20minimal%20magazine%20collage%20composition%2C%20warm%20studio%20light%2C%20textless&width=1200&height=800&seq=gua-event-poster-07&orientation=landscape",
    summary:
      "新剧开机海报公布后，演员名字的排列方式被逐字研究，官方随后在发布会给出排序逻辑说明。",
    heat: 6450,
    status: "持续发酵",
    publishedAt: "2026-09-02",
    updatedAt: "2026-09-10",
    duration: "8 天",
    tags: ["开机", "海报", "番位"],
    timeline: [
      {
        time: "09-02 12:00",
        stage: "发生",
        title: "开机海报正式发布",
        desc: "海报采用双列名字排布，两组演员位置对称，引发排序讨论。",
      },
      {
        time: "09-03 09:30",
        stage: "发酵",
        title: "粉丝开始逐字比对",
        desc: "讨论集中在字号、间距与阅读顺序，出现多种解读方式。",
      },
      {
        time: "09-05 17:00",
        stage: "回应",
        title: "发布会说明排序逻辑",
        desc: "主创表示排序按角色出场与故事线权重安排，与个人分量无关。",
      },
      {
        time: "09-10 11:00",
        stage: "后续",
        title: "剧照物料继续引发讨论",
        desc: "后续物料的站位再次被讨论，话题呈长尾状态。",
      },
    ],
    paragraphs: [
      "一张海报能研究出多少种解读方式，这次给出了一个夸张的答案。双列对称的名字排布，让阅读顺序变得不再唯一，于是字号、间距、甚至换行位置都成了论据。",
      "这类讨论之所以能持续，是因为它没有标准答案。官方不说，解读就永远有空间；官方一旦说了，又可能被质疑是事后补充。发布会上的说明解决了大部分疑问，但长尾讨论并没有完全停止。",
      "值得注意的是，主创给出的排序逻辑相当具体——按角色出场与故事线权重安排。这个说法把讨论从「谁更重要」引向了「角色怎么设计」，其实是一次不错的转移。",
      "目前事件处于长尾阶段，后续物料仍会被拿来比对。对制作方来说，与其反复解释，不如让作品本身说话，这也是大多数类似事件的共同走向。",
    ],
    related: [2, 6, 1],
  },
  {
    id: 8,
    slug: "concert-tickets-sold-out",
    title: "演唱会门票秒空疑云：开票 3 分钟到底发生了什么",
    category: "音乐现场",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20concert%20ticket%20stub%20and%20queue%20arrows%20cut%20from%20coral%20and%20green%20paper%2C%20gold%20accents%2C%20soft%20cream%20background%2C%20minimal%20magazine%20collage%2C%20warm%20light%2C%20textless&width=1200&height=800&seq=gua-event-ticket-08&orientation=landscape",
    summary:
      "一场体育馆演唱会在开票 3 分钟后显示售罄，购票系统排队页面截图被大量转发，主办方与票务平台先后给出说明。",
    heat: 7120,
    status: "已澄清",
    publishedAt: "2026-09-01",
    updatedAt: "2026-09-07",
    duration: "6 天",
    tags: ["演唱会", "开票", "票务"],
    timeline: [
      {
        time: "09-01 20:00",
        stage: "发生",
        title: "开票 3 分钟显示售罄",
        desc: "大量用户停留在排队页面，随后页面显示无票状态，截图迅速扩散。",
      },
      {
        time: "09-02 10:20",
        stage: "发酵",
        title: "排队机制被集中质疑",
        desc: "讨论聚焦在队列公平性与候补顺序是否可见两个方面。",
      },
      {
        time: "09-04 14:00",
        stage: "回应",
        title: "票务平台公开排队逻辑",
        desc: "平台说明队列按进入时间与请求校验分阶段放行，并公布放票批次。",
      },
      {
        time: "09-07 09:00",
        stage: "后续",
        title: "主办方追加少量视野位",
        desc: "主办方释放部分视野受限座位，事件热度回落。",
      },
    ],
    paragraphs: [
      "秒空这件事，真正让人上头的不是结果，而是过程中的不确定。所有人都停在同一个排队页面，看不到自己在队列里的位置，也看不到前面还有多少人，等待就变成了纯粹的焦虑。",
      "质疑集中在两点：队列是否真的按先来后到，以及放票是不是一次放完。前者关系到公平，后者关系到策略。票务平台后来公开了排队逻辑和放票批次，算是把第二个问题解释清楚了。",
      "主办方追加视野受限座位这个动作，反而收获了不错的评价。虽然位置不理想，但它让「一张都抢不到」的情绪有了出口，也是这类事件常见的缓和方式。",
      "事件被标记为已澄清。对观众来说，最有用的经验可能是提前完成实名信息和支付方式设置，因为在秒级放票的场景里，多一步操作就少一次机会。",
    ],
    related: [1, 5, 7],
  },
  {
    id: 9,
    slug: "short-video-copycat-dispute",
    title: "短视频爆款抄袭争议：相似的是结构还是画面",
    category: "网红动态",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20phone%20screen%20frame%20and%20storyboard%20panels%20cut%20from%20coral%20green%20and%20mustard%20paper%2C%20soft%20cream%20backdrop%2C%20minimal%20magazine%20collage%2C%20warm%20studio%20light%2C%20no%20text&width=1200&height=800&seq=gua-event-shortvideo-09&orientation=landscape",
    summary:
      "两条播放量都很高的短视频被指结构雷同，创作者一方公布脚本文档，另一方回应称属于常见叙事模板。",
    heat: 5670,
    status: "进行中",
    publishedAt: "2026-09-02",
    updatedAt: "2026-09-10",
    duration: "8 天",
    tags: ["短视频", "原创", "叙事"],
    timeline: [
      {
        time: "09-02 19:00",
        stage: "发生",
        title: "网友比对两条视频",
        desc: "有人把两条视频剪成左右对照，指出开场、转折与结尾高度相似。",
      },
      {
        time: "09-03 13:00",
        stage: "发酵",
        title: "创作者公布脚本时间戳",
        desc: "其中一方公开脚本文档与修改记录，强调创作在前。",
      },
      {
        time: "09-06 11:00",
        stage: "回应",
        title: "另一创作者回应叙事模板论",
        desc: "对方表示同类题材存在通用叙事结构，画面与表达均为独立完成。",
      },
      {
        time: "09-10 09:00",
        stage: "后续",
        title: "讨论转向原创界定标准",
        desc: "话题从个案扩展到短视频原创性的边界，热度维持中等水平。",
      },
    ],
    paragraphs: [
      "这起争议的看点在于「像」的定义。两条视频放在一起看，开场方式、节奏转折和情绪落点确实接近，但画面素材、口播文案和出镜方式又完全不同。相似的是结构，还是表达，成了争论的核心。",
      "创作者公布脚本时间戳，是一种很聪明的自证方式。它把讨论从主观感受拉到了可核对的时间线上，也让「谁先谁后」这个问题有了相对客观的参照。",
      "另一方的回应也站得住脚：同类题材本身就存在被反复使用的叙事模板，模板相似不等于内容抄袭。这个说法在行业里并不新鲜，但在个案里触碰到了短视频原创界定的灰色地带。",
      "讨论发展到现在，已经跳出个案，变成了对「原创标准」的公共探讨。对于一个记录热点的站点来说，这正是值得保留的部分——事件会过去，但它提出的问题会留下来。",
    ],
    related: [5, 3, 8],
  },
];